module.exports = __webpack_public_path__ + "img/icon_1_46.293db039.png";